import { TimeMutationDto, TimeOverviewDto } from '../registrationConfig'

export const mapTimeOverviewDtoToMutation = (dto: TimeOverviewDto): TimeMutationDto => ({
    userId: dto.user?.id,
    duration: dto.duration,
    description: dto.description || undefined,
    date: dto.date,
    rate: dto.rate?.amount,
    currency: dto.rate?.currency,
    billable: dto.billable,
    fileId: dto.file?.id,
    category: dto.category ?? undefined,
})

export type TurnOverItem = {
    billable: Billable
    duration: string
}

export enum Billable {
    Billable = 'BILLABLE',
    Offered = 'OFFERED',
    NotBillable = 'NOT_BILLABLE',
}

export enum TimeAction {
    GetOverview = 'GET_TIME_OVERVIEW',
    Add = 'ADD_TIME',
    Update = 'UPDATE_TIME',
    Delete = 'DELETE_TIME',
    ResetOverview = 'RESET_TIME_OVERVIEW',
    OverviewSettings = 'TIME_OVERVIEW_SETTINGS',
}
